import { render, staticRenderFns } from "./McaForm.vue?vue&type=template&id=cf2f06de&scoped=true"
import script from "./McaForm.vue?vue&type=script&lang=ts"
export * from "./McaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2f06de",
  null
  
)

export default component.exports